<app-header></app-header>
<app-menu></app-menu>


<div nxLayout="grid" class="nx-margin-top-2m">

    <div nxRow class="nx-margin-left-5xl nx-margin-right-4m">
        <div nxCol="2">
            <nx-formfield label="E- Invoice Status">
                <nx-dropdown #statusDropdown [(value)]="invoiceStatus" (selectionChange)="onStatusChanges()">
                    <nx-dropdown-item value="Pending"></nx-dropdown-item>
                    <nx-dropdown-item value="Completed"></nx-dropdown-item>
                </nx-dropdown>
            </nx-formfield>
        </div>
    </div>

    <div nxRow class="nx-margin-left-5xl nx-margin-right-4m">
        <div nxCol="10" colOffset="1">
            <table nxTable zebra condensed nxSort (sortChange)="sortTable($event)">
                <thead>
                    <tr nxTableRow>
                        <th nxHeaderCell nxSortHeaderCell="policyNo">
                            Policy Number
                        </th>
                        <th nxHeaderCell nxSortHeaderCell="policyName">
                            Policy Name
                        </th>
                        <th nxHeaderCell nxSortHeaderCell="customerFirstName">
                            Customer Name
                        </th>
                        <th nxHeaderCell nxSortHeaderCell="customerMobileNo">
                            Mobile Number
                        </th>
                        <th nxHeaderCell nxSortHeaderCell="customerEmail">
                            Email
                        </th>
                        <th nxHeaderCell nxSortHeaderCell="paymentDate">
                            Created Date
                        </th>

                        <th nxHeaderCell>
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody class="txtalign_center" >
                    <tr nxTableRow *ngFor="let item of policyList">
                        <td nxTableCell>{{item.policyNo}}</td>
                        <td nxTableCell>{{item.policyName}}</td>
                        <td nxTableCell>{{item.customerFirstName}} {{item.customerLastName}}</td>
                        <td nxTableCell>{{item.customerMobileNo}}</td>
                        <td nxTableCell>{{item.customerEmail}}</td>
                        <td nxTableCell>{{item.paymentDate | date:'MM/dd/yyyy'}}</td>
                        <td nxTableCell>
                            <nx-context-menu #menu="nxContextMenu">
                                <ng-template nxContextMenuContent>
                                    <!-- <button (click)="download($event,item.policyNo)"nxContextMenuItem type="button">Download Upload-Format</button> -->
                                    <button (click)="upload($event,item.policyNo)" nxContextMenuItem
                                        type="button">Upload E-Invoice</button>
                                </ng-template>
                            </nx-context-menu>
                            <button nxIconButton="tertiary medium" type="button" [nxContextMenuTriggerFor]="menu"
                                aria-label="Open menu" [nxTooltipPosition]="'top'" [nxTooltip]="'Please click here'">
                                <nx-icon aria-hidden="true" name="ellipsis-h"></nx-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div nxRow class="nx-margin-left-5xl nx-margin-right-2xs fright">
                <div nxCol="6">
                    <nx-pagination [count]="count" [page]="pageNumber" [perPage]="pageSize" type="advanced"
                        (goPrev)="prevPage()" (goNext)="nextPage()" (goPage)="goToPage($event)">
                    </nx-pagination>
                </div>
            </div>
        </div>
        <div nxCol="12,10" class="nx-margin-top-2xl" *ngIf="count==0">
            <ng-container>
                <div nxRow rowJustify="center">
                    <div nxCol="12" class="nosearchresult"></div>
                    <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">No Records found !!!</h3>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<app-footer></app-footer>

<ng-template #confirmModal *ngIf="UploadInvoiceModal">
    <div nxRow rowJustify="start,around">
        <h3 class="modal-heading" nxHeadline="subsection-small">Upload E-Invoice (*.pdf files only)</h3>
    </div>
    <div class="modal-dialog modal-lg">
        <div nxLayout="grid" class="nx-margin-top-2m">
            <div class="row-container">
                <div nxRow>
                    <div nxCol="12">
                        <app-upload (onUploadFinished)="checkUploadFinished($event)" [acceptedfiles]="accpetedTypes"
                            [uploadPath]="uploadPath"></app-upload>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div nxRow class="nx-margin-top-2m">
        <div nxCol="12" class="centered">
            <button nxModalClose="Yes" (click)="download()" nxButton="block primary">
                <nx-icon size="l" name="xls" class="nx-margin-right-2xs"></nx-icon>Click here to download customer
                details
            </button>
        </div>
        <div nxCol="6">
            <button nxModalClose="No" (click)="modalClose()" nxButton="block primary">
                No
            </button>
        </div>
    </div>
</ng-template>